
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartLegend, ChartLegendContent } from '@/components/ui/chart';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from 'recharts';
import { chemicalSafetyRadarData } from '@/data/chemicalSafetyData';

const chartConfig = {
  yourScore: {
    label: 'Your Score',
    color: '#3b82f6'
  },
  industryAverage: {
    label: 'Industry Average',
    color: '#94a3b8'
  },
  topPerformer: {
    label: 'Top Performer',
    color: '#22c55e'
  }
};

export const SafetyRadarChart = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Safety Performance Radar</CardTitle>
        <p className="text-sm text-muted-foreground">
          Multi-dimensional view of safety endpoint performance
        </p>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={chemicalSafetyRadarData} margin={{ top: 20, right: 80, bottom: 20, left: 80 }}>
              <PolarGrid />
              <PolarAngleAxis dataKey="endpoint" tick={{ fontSize: 12 }} />
              <PolarRadiusAxis 
                angle={90} 
                domain={[0, 100]} 
                tick={{ fontSize: 10 }}
                tickCount={6}
              />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Radar
                name="Your Score"
                dataKey="yourScore"
                stroke="var(--color-yourScore)"
                fill="var(--color-yourScore)"
                fillOpacity={0.1}
                strokeWidth={2}
              />
              <Radar
                name="Industry Average"
                dataKey="industryAverage"
                stroke="var(--color-industryAverage)"
                fill="var(--color-industryAverage)"
                fillOpacity={0.1}
                strokeWidth={2}
              />
              <Radar
                name="Top Performer"
                dataKey="topPerformer"
                stroke="var(--color-topPerformer)"
                fill="var(--color-topPerformer)"
                fillOpacity={0.1}
                strokeWidth={2}
              />
            </RadarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
